module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-locked-04997088746fe5ebbdc5bfd591ee6ce4.svg";